import { isNumeric } from "../../../utilities/strings";
import {CAPSULE_SIZES} from '../../../resources/constants';
/**
 * validate
 * @param {*} setErrors
 * @param {*} state
 * @returns
 */
const validate = (setErrors, state) => {
  const {capsuleCount,capsuleSize,excipientPackStat,apiList} = state;

  let newErrors = {};
  let validated = true;

  //handle capsuleCount
  if (!isNumeric(capsuleCount) ||  capsuleCount<=0) {
    newErrors.capsuleCount = "Please supply a valid capsule count";
    validated = false;
  }

  //handle capsuleSize
  if (!CAPSULE_SIZES.includes(capsuleSize)) {
    newErrors.capsuleSize = "Please supply a valid size";
    validated = false;
  }

  //handle excipientPackStat
  if (!isNumeric(excipientPackStat) || excipientPackStat<=0) {
    newErrors.excipientPackStat = "Please supply a valid excipient pack stat";
    validated = false;
  }

  //handle apiList errors
  let apiErrors = [];
  apiList.forEach((item, i) => {
    const { quantity,packStat } = item;
    let apiError = {};
    if (!isNumeric(quantity)) {
      apiError.quantity = "Please supply a valid quantity";
      validated = false;
    }
    if (!isNumeric(packStat) || packStat<=0) {
      apiError.packStat = "Please supply a valid pack stat";
      validated = false;
    }
    apiErrors.push(apiError);
  });
  newErrors.apiList = apiErrors;

  //set and return
  setErrors(newErrors);
  return validated;
};

export default validate;
